<template>
    <h2 class="mb-0">
        <button v-if="item.title" @click="handleClick" :aria-expanded="isActive ? 'true' : 'false'" :class="{ 'active': isActive }">
            {{ item.title }}
        </button>
    </h2>
</template>

<script>
export default {
    name: "TabButton",

    props: ['selectedId', 'item'],

    computed: {
        isActive() {
            return _.isEqual(this.item.id, this.selectedId);
        }
    },

    methods: {
        handleClick() {
            this.$emit('selected-tab', this.item.id);
        }
    }
}
</script>
